import React from 'react'
import './MemberApplicationTaskListDetailForm.scss'
import ViewApplicationTaskListTable from '../../features/ViewApplicationTaskList/ViewApplicationTaskListTable'

const ViewApplicationTaskList = () => {
  return (
    <div>
      <ViewApplicationTaskListTable />
      {/* ViewApplicationTaskList */}
    </div>
  )
}

export default ViewApplicationTaskList
